import { render, staticRenderFns } from "./information-box.vue?vue&type=template&id=3a319992&scoped=true&"
import script from "./information-box.vue?vue&type=script&lang=js&"
export * from "./information-box.vue?vue&type=script&lang=js&"
import style0 from "./information-box.vue?vue&type=style&index=0&id=3a319992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a319992",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
